import { get } from "lodash";
import client from "@irati/utils/services/apollo";
import authentication from "@irati/auth";
import { query as getWallet } from "@irati/wallet/apollo/query/RewardWallet";
import getRewardOrder from "./queries/GetRewardOrder";
import createReward from "./queries/CreateReward";
import confirmRewardPaymentPayment from "./queries/ConfirmRewardPaymentOrder";
import sendCreditAsReward from "./queries/SendCreditAsReward";
var Reward = /** @class */ (function () {
    function Reward() {
    }
    Reward.prototype.getRewardOrder = function (rewardOrderId) {
        var variables = {
            tenantId: authentication.userTenant().uuid,
            orderId: rewardOrderId
        };
        return client.query({ query: getRewardOrder, variables: variables }).then(function (res) { return res.data.rewardOrder; });
    };
    Reward.prototype.create = function (payload) {
        return client.mutate({ mutation: createReward, variables: { payload: payload } }).then(function (res) { return res.data.createReward; });
    };
    Reward.prototype.getWallet = function () {
        var variables = {
            currency: authentication.defaultUserCurrency(),
            tenantId: authentication.userTenant().uuid,
            userId: authentication.user().uuid
        };
        return client.query({ query: getWallet, variables: variables, fetchPolicy: "cache-first" }).then(function (res) { return get(res, "data.rewardWallets.results[0]"); });
    };
    Reward.prototype.confirmRewardPaymentOrder = function (rewardOrderId) {
        var variables = {
            tenantId: authentication.userTenant().uuid,
            orderId: rewardOrderId
        };
        return client.mutate({ mutation: confirmRewardPaymentPayment, variables: variables }).then(function (res) { return res.data; });
    };
    Reward.prototype.sendCreditAsReward = function (walletId, rewardOrderId) {
        var variables = {
            tenantId: authentication.userTenant().uuid,
            userId: authentication.user().uuid,
            walletId: walletId,
            rewardOrderId: rewardOrderId
        };
        return client.mutate({ mutation: sendCreditAsReward, variables: variables }).then(function (res) { return res; });
    };
    return Reward;
}());
var RewardService = new Reward();
export default RewardService;
